export default "__VITE_ASSET__CiIvMF7F__"